export default "__VITE_ASSET__tZwySts0__"